<template>
    <div>
        <div class="top_title fixed fixed2">共{{total}}件商品</div>
        <home-scroll url="goods/index-v2" :params="params" :method="'get'" :nrtxt="''" @on-fetch="fetch">
            <template slot-scope="scope">
                <div class="goods_list">
                    <index-goods v-for="(row,i) in scope.data" :row="row" :key="i"/>
                </div>
            </template>
        </home-scroll>
    </div>
</template>
<script>
export default {
    data() {
        return {
            total: 0
        }
    },
    computed: {
        keywords() {
            return this.$store.state.keywords
        },
        params() {
            return {
                app_id: this.$store.state.gameId,
                keyword: this.$store.state.keywords,
                server_id: this.$store.state.home_server_id,
                category_id: this.$store.state.category_id2
            }
        }
    },
    methods: {
        fetch(e) {
            this.total = e.total
        }
    },
}
</script>
<style lang="less">
    
</style>